import { http } from './http';

export const googleAuthentication = (response: any) =>
  http.post('signup/google', JSON.stringify({ token: response.code }));

export const googleSignIn = (response: { token: string }) =>
  http.post('login/google', JSON.stringify({ token: response.code }));
